import { render, staticRenderFns } from "./AdvanceMenu.vue?vue&type=template&id=56531b8d"
import script from "./AdvanceMenu.vue?vue&type=script&lang=js"
export * from "./AdvanceMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports